require('./aucun-incident-detecte.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class AucunIncidentDetecteComponent {
  constructor() {
    this.controller = AucunIncidentDetecteController;
    this.template = require('./aucun-incident-detecte.html');
  }
}

// @ngInject
class AucunIncidentDetecteController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.AUCUN_INCIDENT_DETECTE));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.aucunIncidentDetecte ? state.demande.data.aucunIncidentDetecte.asMutable({deep: true}) : this.data
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAucunIncidentDetecte(this.data, true));
  }
  nextStep(continuerPrtv) {
    this.data.continuerPrtv = continuerPrtv;
    this.$ngRedux.dispatch(DemandeActions.updateAucunIncidentDetecte(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/aucun-incident-detecte/aucun-incident-detecte.component.js